(function(window, endActionTypeConstantsFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.endActionType = endActionTypeConstantsFactory();
})(this, function() {
   'use strict';

   return Object.freeze({
      notAvailable: 'notAvailable',
      loop: 'loop',
      jumpToTimeAndPlay: 'jumpToTime',
      jumpToTImeAndStop: 'jumpToTimeAndStop',
      showReplayControls: 'showReplayControls',
      hideReplayControls: 'hideReplayControls',
      openUrl: 'openUrl',
      openUrlInNewWindow: 'openUrlInNewWindow'
   });
});

